export default __webpack_public_path__ + "images/sweep7.4932cd292325c04c643418c621e7ecc0.gif";